import axios from '@/api/axiosConfig'
import { ApiRoutes } from '../ApiRoutes'
import type { ApiResponse } from '@/types/apiTypes';
import type { AxiosResponse } from 'axios';


export async function getAuthenticationRedirectUrl(type: string): Promise<AxiosResponse<ApiResponse<string>>> {
  return await axios.get(ApiRoutes.Authentication.GetAuthenticationRedirectUrl, { params: { type } });
}
